import React from 'react';
import { CardMedia } from '@material-ui/core';
import styles from '../../../App.module.scss';
import defaultImg from '../../../assets/icon_not_loading.png';
import ctx from 'classnames';

interface IconProps {
  src?: string;
  name?: string;
  size?: 'sm' | 'lg'
}
export const AppIcon: React.FC<IconProps> = ({src, name, size= 'lg'}): JSX.Element => {
  return (
    <CardMedia
      classes={{
        root: ctx(styles.icon, styles[size])
      }}
      src={src || defaultImg}
      component="img"
      onError={(e: any) => {
        e.target.src = defaultImg;
      }}
      title={name}
      alt= ''
      aria-hidden='true'
      data-testid='appIcon'
    />
  )
}
